import React from 'react';
import { apiHelperCollections } from 'src/api/helpers/collection';
import { collectionStatusIconMap } from 'src/api/consts/CollectionStatus';
import Icon from 'src/ui/WasteFractionTag/Icon';
import { cn } from '@/lib/utils';

type CalendarCellProps = {
  item: $TSFixMe;
  onClick?: () => void;
};

const CalendarCell = ({ item, onClick }: CalendarCellProps) => {
  const wasteFraction = item?.container?.waste_fraction;
  const status = apiHelperCollections.getStatus(item);
  const tickets = item?.pickup_order?.created_tickets || [];
  const isInteractive = !!tickets?.length;
  const isMissed = status === 'MISSED';
  const color = wasteFraction?.color || '#141414';

  return (
    <div
      role={isInteractive ? 'button' : undefined}
      tabIndex={isInteractive ? 0 : undefined}
      onClick={isInteractive ? onClick : undefined}
      onKeyDown={
        isInteractive
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick?.();
              }
            }
          : undefined
      }
      className={cn(
        'flex w-full min-w-0 items-center gap-2 rounded-lg outline-none',
        'focus-visible:ring-2 focus-visible:ring-[var(--border-focus)]',
        isInteractive ? 'cursor-pointer' : 'cursor-default'
      )}
    >
      <div
        className="flex size-6 shrink-0 items-center justify-center rounded-[4px] overflow-hidden"
        style={{ backgroundColor: color }}
      >
        {wasteFraction?.icon_preset && (
          <Icon
            identifier={wasteFraction.icon_preset}
            style={{ fontSize: 16, color: '#fff' }}
          />
        )}
        {!wasteFraction?.icon_preset && wasteFraction?.icon && (
          <img
            src={wasteFraction.icon}
            alt=""
            className="size-full object-cover"
          />
        )}
        {!wasteFraction?.icon_preset && !wasteFraction?.icon && (
          <span className="text-xs font-semibold text-white leading-none">
            {wasteFraction?.name?.slice(0, 1)}
          </span>
        )}
      </div>
      <span
        className={cn(
          'min-w-0 flex-1 truncate text-base font-medium leading-[1.5] text-[var(--text-primary)]',
          isMissed && 'line-through opacity-60'
        )}
        title={wasteFraction?.name}
      >
        {wasteFraction?.name}
      </span>
      {status && collectionStatusIconMap[status] && (
        <span className="flex shrink-0 items-center leading-none">
          {collectionStatusIconMap[status]}
        </span>
      )}
    </div>
  );
};

export default CalendarCell;
